import Chart from "chart.js/auto";

export const chartHelper = {
  getChart: function(elementId, gridColor, tickColor, dataColor, legendColor)
  {
    let element = document.getElementById(elementId);
    if(element === null){
      throw new Error("Element not found");
    }
    return new Chart(element,
      {
        type: "line",
        animation: false,
        options: {
          scales: {
            x: {
              grid: {
                display: true,
                drawOnChartArea: false,
                drawTicks: true,
                borderDash: [5, 5],
                color: gridColor,
                drawBorder: false
              },
              border: {
                color: gridColor,
                lineWidth: 1,
                display: true,
                borderDash: [5, 5]
              }

            },
            y: {
              position: "right",
              min: 0,
              grid: {
                drawOnChartArea: false,
                drawTicks: false,
                drawBorder: false
              },
              border: {
                display: false
              },
              ticks: {
                color: tickColor,
                beginAtZero: true,
                stepSize: 100,
                padding: 6,
                align: "start"
              },
              afterDataLimits(scale)
              {
                scale.max *= 1.05;
              }
            }
          },
          plugins: {
            legend: {
              display: true,
              position: "top",
              align: "start",
              labels: {
                filter: (item) => item.text !== "" && typeof item.text !== "undefined",
                color: legendColor,
                font: { size: 12, weight: "500" },
                usePointStyle: true,
                pointStyle: "circle",
                boxWidth: 8,
                boxHeight: 8,
                padding: 4
              }
            }
          }
        },
        data: {
          labels: [],
          datasets: [
            {
              data: [],
              borderColor: dataColor,
              backgroundColor: dataColor,
              pointRadius: 4,
              pointHoverRadius: 6,
              label: ""
            }
          ]
        }
      });
  }
};
